import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class BusinessIntelligenceSuppliersService {
  getSupplierAwards({ supplier, year, month }) {
    const baseUrl = `${Config.api.bi.url}api/v1/charts/get_awards?supplier=${supplier}`;
    const params = [];
    if (year) params.push(`year=${year}`);
    if (month) params.push(`month=${month}`);
    const url = params.length ? `${baseUrl}&${params.join('&')}` : baseUrl;
    return ApiService.get(url).then((response) => {
      return response.data;
    });
  }
  getSupplierBids({ supplier, year, month }) {
    const baseUrl = `${Config.api.bi.url}api/v1/charts/get_bids?supplier=${supplier}`;
    const params = [];
    if (year) params.push(`year=${year}`);
    if (month) params.push(`month=${month}`);
    const url = params.length ? `${baseUrl}&${params.join('&')}` : baseUrl;
    return ApiService.get(url).then((response) => {
      return response.data;
    });
  }
}

export const businessIntelligenceSuppliersService = new BusinessIntelligenceSuppliersService();
